module.exports = "/images/about_logo_cmrad.png?3dcbb3755da7cd36beea50bb81375e53";